import { RequestFactory } from '../../types/sdk'
import { IUserInvitationsResponse } from '../../types/user'

export function createModule(rf: RequestFactory) {
  return {
    getInvitationsForUser: () => rf.get<IUserInvitationsResponse>(`/app/invitations`)
  }
}
